import { NamedLocationAdapter } from './NamedLocationAdapter';
export class StringPrefillQueryAdapter {
    static fromGraphQL(queryResult) {
        if (!queryResult || !queryResult.locationInputComponentStringPrefill) {
            return {
                isValid: false,
                location: undefined,
                formattedName: '',
            };
        }
        const componentResult = {
            location: NamedLocationAdapter.fromGraphQL(queryResult.locationInputComponentStringPrefill.location),
            formattedName: queryResult.locationInputComponentStringPrefill.formattedName || '',
            isValid: true,
        };
        return componentResult;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RyaW5nUHJlZmlsbFF1ZXJ5QWRhcHRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91cml0aGlydS1jbGllbnQvYWRhcHRlcnMvU3RyaW5nUHJlZmlsbFF1ZXJ5QWRhcHRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsb0JBQW9CLEVBQUUsTUFBTSx3QkFBd0IsQ0FBQztBQUU5RCxNQUFNLE9BQU8seUJBQXlCO0lBQzNCLE1BQU0sQ0FBQyxXQUFXLENBQ3JCLFdBQWlFO1FBRWpFLElBQUksQ0FBQyxXQUFXLElBQUksQ0FBQyxXQUFXLENBQUMsbUNBQW1DLEVBQUUsQ0FBQztZQUNuRSxPQUFPO2dCQUNILE9BQU8sRUFBRSxLQUFLO2dCQUNkLFFBQVEsRUFBRSxTQUFTO2dCQUNuQixhQUFhLEVBQUUsRUFBRTthQUNZLENBQUM7UUFDdEMsQ0FBQztRQUNELE1BQU0sZUFBZSxHQUFpQztZQUNsRCxRQUFRLEVBQUUsb0JBQW9CLENBQUMsV0FBVyxDQUN0QyxXQUFXLENBQUMsbUNBQW1DLENBQUMsUUFBUSxDQUMzRDtZQUNELGFBQWEsRUFBRSxXQUFXLENBQUMsbUNBQW1DLENBQUMsYUFBYSxJQUFJLEVBQUU7WUFDbEYsT0FBTyxFQUFFLElBQUk7U0FDaEIsQ0FBQztRQUNGLE9BQU8sZUFBZSxDQUFDO0lBQzNCLENBQUM7Q0FDSiJ9